import React, { useState, useEffect } from 'react';
import Wrapper from '../../Main/Universal/Wrapper';
import { formatDate2, postAPI } from '../../../app/api';
import viewIcon from "../../../theme/assets/images/icon/view-icon-02.svg"
import deleteIcon from "../../../theme/assets/images/icon/delete-icon.svg"
import Swal from 'sweetalert2';

export default function Contacts() {
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [viewContact, setViewContact] = useState(null);
    const [editingId, setEditingId] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
        status: 'active'
    });

    // Fetch all contacts
    useEffect(() => {
        fetchContacts();
    }, []);

    const fetchContacts = async () => {
        try {
            setLoading(true);
            const response = await postAPI('contact/list', {});
            if (response?.status === 1) {
                setContacts(response?.data || []);
            }
        } catch (error) {
            console.error('Error fetching website messages:', error);
            Swal.fire('Error', 'Failed to fetch website messages', 'error');
        } finally {
            setLoading(false);
        }
    };

    // Handle form changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Add new contact
    const handleAddContact = async (e) => {
        e.preventDefault();
        try {
            if (!formData.name || !formData.email || !formData.phone) {
                Swal.fire('Validation', 'Please fill all required fields', 'warning');
                return;
            }

            const response = await postAPI('contact/create', formData);
            if (response?.status === 1) {
                Swal.fire('Success', 'Contact added successfully', 'success');
                setFormData({ name: '', email: '', phone: '', message: '', status: 'active' });
                setShowForm(false);
                fetchContacts();
            } else {
                Swal.fire('Error', response?.msg || 'Failed to add contact', 'error');
            }
        } catch (error) {
            console.error('Error adding contact:', error);
            Swal.fire('Error', error.message || 'Failed to add contact', 'error');
        }
    };

    // Delete contact
    const handleDeleteContact = async (id) => {
        const result = await Swal.fire({
            title: 'Confirm Delete',
            text: 'Are you sure you want to delete this contact?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            try {
                // Note: Update this endpoint if backend has a delete endpoint
                const response = await postAPI('contact/delete', { id });
                if (response?.status === 1) {
                    Swal.fire('Success', 'Contact deleted successfully', 'success');
                    fetchContacts();
                }
            } catch (error) {
                Swal.fire('Error', 'Failed to delete contact', 'error');
            }
        }
    };

    const handleToggleForm = () => {
        if (showForm) {
            // If form is shown, close it and reset
            setShowForm(false);
            setEditingId(null);
            setFormData({ name: '', email: '', phone: '', message: '', status: 'active' });
        } else {
            // If form is hidden, show it with fresh data
            setEditingId(null);
            setFormData({ name: '', email: '', phone: '', message: '', status: 'active' });
            setShowForm(true);
        }
    };

    // Handle view contact details
    const handleView = (contact) => {
        setViewContact(contact);
        setShowViewModal(true);
    };

    return (
        <>
            <Wrapper>
                <div className="container-fluid">
                    <div className="row mb-4">
                        <div className="col-12">
                            <div className="d-flex justify-content-between align-items-center">
                                <h3 className="mb-0">Website Messages</h3>
                                {/* <button 
                                    className="btn btn-primary"
                                    onClick={handleToggleForm}
                                >
                                    {showForm ? 'Cancel' : 'Add New Contact'}
                                </button> */}
                            </div>
                        </div>
                    </div>

                    {showForm && (
                        <div className="card mb-4">
                            <div className="card-body">
                                <h5 className="card-title">{editingId ? 'Edit Contact' : 'Add New Contact'}</h5>
                                <form onSubmit={handleAddContact}>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Name *</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Email *</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Phone *</label>
                                            <input
                                                type="tel"
                                                className="form-control"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Status</label>
                                            <select
                                                className="form-control"
                                                name="status"
                                                value={formData.status}
                                                onChange={handleChange}
                                            >
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </select>
                                        </div>
                                        <div className="col-12 mb-3">
                                            <label className="form-label">Message</label>
                                            <textarea
                                                className="form-control"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                rows="3"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <button type="submit" className="btn btn-success">
                                        {editingId ? 'Update' : 'Add'} Contact
                                    </button>
                                </form>
                            </div>
                        </div>
                    )}

                    <div className="card">
                        <div className="card-body">
                            {loading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-striped table-hover cus-table">
                                        <thead className="table-dark">
                                            <tr>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Message</th>
                                                {/* <th>Status</th> */}
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {contacts && contacts.length > 0 ? (
                                                contacts.map((contact, index) => {
                                                    // Debug log to see what each contact object holds
                                                    console.log('Rendering contact:', contact);
                                                    const displayName = (contact.first_name || contact.last_name)
                                                        ? `${contact.first_name || ''} ${contact.last_name || ''}`.trim()
                                                        : contact.name || '-';
                                                    const displayEmail = contact.email_id || contact.email || '-';

                                                    return (
                                                        <tr key={index}>
                                                            <td>{displayName}</td>
                                                            <td>{displayEmail}</td>
                                                            <td>{contact.message?.substring(0, 30)}...</td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-sm px-0 py-0 me-2"
                                                                    onClick={() => handleView(contact)}
                                                                    title="View Details"
                                                                >
                                                                    <img src={viewIcon} />
                                                                </button>

                                                                <button
                                                                    className="btn btn-sm px-0 py-0 me-2"
                                                                    onClick={() => handleDeleteContact(contact.id)}
                                                                >
                                                                    <img src={deleteIcon} />
                                                                </button>
                                                            </td>
                                                            {/* <td>
                                                            <span className={`badge badge-${contact.status === 1 ? 'success' : 'danger'}`}>
                                                                {contact.status === 1 ? 'Active' : 'Inactive'}
                                                            </span>
                                                        </td> */}
                                                            {/* Delete & Reply Option - UI GRecaptcha Verification  */}
                                                            {/* <td>
                                                            <button
                                                                className="btn btn-sm btn-warning me-2"
                                                                onClick={() => {
                                                                    setFormData(contact);
                                                                    setEditingId(contact.id);
                                                                    setShowForm(true);
                                                                }}
                                                            >
                                                                Edit
                                                            </button>
                                                        </td> */}
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className="text-center py-4">
                                                        No website messages found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* View Contact Details Modal */}
                <div className={`modal fade ${showViewModal ? "show d-block modal-white" : ""}`} tabIndex="-1" style={{ background: showViewModal ? "rgba(0,0,0,0.5)" : "transparent" }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Contact Message Details</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowViewModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                {viewContact && (
                                    <div className="row">
                                        <div className="col-12 mb-3">
                                            <h6 className="text-muted">Contact Information</h6>
                                            <table className="table table-bordered">
                                                <tbody>
                                                    <tr>
                                                        <th style={{ width: '25%' }}>Name</th>
                                                        <td><strong>{viewContact.first_name || viewContact.last_name ? `${viewContact.first_name || ''} ${viewContact.last_name || ''}` : viewContact.name}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <th>Email</th>
                                                        <td>{viewContact.email_id || viewContact.email || '-'}</td>
                                                    </tr>
                                                    {/* <tr>
                                                        <th>Subject</th>
                                                        <td>{viewContact.subject || '-'}</td>
                                                    </tr> */}
                                                    <tr>
                                                        <th>Message</th>
                                                        <td style={{ whiteSpace: 'pre-wrap' }}>{viewContact.message || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Date Submitted</th>
                                                        {/* <td>{viewContact.createdAt ? new Date(viewContact.createdAt).toLocaleString() : '-'}</td> */}
                                                        <td>{viewContact.createdAt ? <>{formatDate2(viewContact.createdAt)?.month} {formatDate2(viewContact.createdAt)?.day}, {formatDate2(viewContact.createdAt)?.year}</> : '-'}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowViewModal(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Wrapper>
        </>
    );
}
